import { render, staticRenderFns } from "./ParticipantImageName.vue?vue&type=template&id=4a94c3fa&scoped=true"
import script from "./ParticipantImageName.vue?vue&type=script&lang=js"
export * from "./ParticipantImageName.vue?vue&type=script&lang=js"
import style0 from "./ParticipantImageName.vue?vue&type=style&index=0&id=4a94c3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94c3fa",
  null
  
)

export default component.exports